import { withNamespaces } from "react-i18next"
import Accordion from 'react-bootstrap/Accordion';
import GeneralInformationImage from "src/modules/3rd-party-management/assets/images/general-information.svg";
import { Card, CardBody, Col, Row, UncontrolledTooltip } from "reactstrap";

import { 
    RiBuilding4Line,
    RiMapPinLine,
    RiContactsLine,
    RiBriefcaseLine,
    RiInformationLine,
    RiCheckLine,
    RiCloseLine
} from "react-icons/ri";
import DateUtils from "src/services/utils/DateUtils";
import  { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';

const GeneralInfo = ({
    t,
    activeAccordion, 
    setActiveAccordion,

    infoQuery
}) => {
    const dateUtils = new DateUtils();

    if (infoQuery.isFetching) {
        return (
            <Row>
                <Col 
                    sm="12" 
                    className="mt-4 mb-4"
                >
                    <div 
                        className="dt-field dt-skeleton" 
                        style={{ width: '100%', height: '100px' }}
                    />
                </Col>
            </Row>
        )
    }

    const {
        company
    } = infoQuery.data || {};

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('general-info')}
            className={activeAccordion === 'general-info' ? 'active' : ''}
            eventKey={'general-info'}
        >
            <Accordion.Header>
                <img 
                    src={GeneralInformationImage} 
                    alt="" 
                />
                <span>
                    {t('Company Information')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                <Row className="g-3 mb-4">
                    <Col sm="12" md="12">
                        <Card className="h-100 h-100 shadow-sm">
                            <CardBody className="p-1">
                                <div className="d-flex align-items-center mb-2">
                                    <span className="me-2 text-primary">
                                        <RiBuilding4Line size="24" />
                                    </span>
                                    <div className="fw-bold font-size-16">
                                        {t('Identity & Legal Info')}
                                    </div>
                                </div>
                                
                                <Row>
                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Primary Name')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.primaryName}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Trade Name')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.tradeName || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Former Primary Name')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.formerPrimaryName || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('DUNS Number')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.duns || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Former DUNS Number')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.formerDuns || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Business Number')}
                                                    <span
                                                        id="tooltip-businessNumber"
                                                        className="ms-1"
                                                        style={{ cursor: "pointer" }}>
                                                        <RiInformationLine />
                                                    </span>
                                                    <UncontrolledTooltip
                                                        target="tooltip-businessNumber"
                                                    >
                                                        {t('Primary business identification number assigned by a government agency, Chamber of Commerce, or association.')}
                                                    </UncontrolledTooltip>
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.businessNumber || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Business Number Type')}
                                                    <span
                                                        id="tooltip-businessNumberType"
                                                        className="ms-1"
                                                        style={{ cursor: "pointer" }}>
                                                        <RiInformationLine />
                                                    </span>
                                                    <UncontrolledTooltip
                                                        target="tooltip-businessNumberType"
                                                    >
                                                        {t('Code representing the type of business identification number.')}
                                                    </UncontrolledTooltip>
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.businessNumberType || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>

                    {/* 2. Establishment Address */}
                    <Col sm="12" md="12">
                        <Card className="h-100 h-100 shadow-sm">
                            <CardBody className="p-1">
                                <div className="d-flex align-items-center mb-2">
                                    <span className="me-2 text-primary">
                                        <RiMapPinLine size="24" />
                                    </span>
                                    <div className="fw-bold font-size-16">
                                        {t('Establishment Address')}
                                    </div>
                                </div>
                                
                                <Row>
                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Street')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.establishmentAddress || "—"}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Postcode')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.establishmentAddressPostCode || "—"}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('City')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.establishmentAddressCity || "—"}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Region')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.establishmentAddressRegion || "—"}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Country')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.establishmentAddressCountry || "—"}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Region Short')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.establishmentAddressRegionShort || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Region Code')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.establishmentAddressRegionCode || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Country ISO')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.establishmentAddressCountryIso || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Country DNB Code')}
                                                    <span
                                                        id="tooltip-establishmentAddressCountryDnb"
                                                        className="ms-1"
                                                        style={{ cursor: "pointer" }}>
                                                        <RiInformationLine />
                                                    </span>
                                                    <UncontrolledTooltip
                                                        target="tooltip-establishmentAddressCountryDnb"
                                                    >
                                                        {t('D&B internal country code.')}
                                                    </UncontrolledTooltip>
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.establishmentAddressCountryDnb || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Deliverability Indication')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.establishmentDeliverabilityIndication ? (
                                                        <>
                                                            <RiCheckLine size="20" className="text-primary" />
                                                            {t('Yes')}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <RiCloseLine size="20" className="text-danger" />
                                                            {t('No')}
                                                        </>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Correspondence Deliverability Indication')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.correspondenceDeliverabilityIndication ? (
                                                        <>
                                                            <RiCheckLine size="20" className="text-primary" />
                                                            {t('Yes')}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <RiCloseLine size="20" className="text-danger" />
                                                            {t('No')}
                                                        </>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Correspondence Address')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.correspondenceAddress || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>

                    {/* Correspondence Address */}
                    <Col sm="12" md="12">
                        <Card className="h-100 h-100 shadow-sm">
                            <CardBody className="p-1">
                                <div className="d-flex align-items-center mb-2">
                                    <span className="me-2 text-primary">
                                        <RiMapPinLine size="24" />
                                    </span>
                                    <div className="fw-bold font-size-16">
                                        {t('Correspondence Address')}
                                    </div>
                                </div>
                                
                                <Row>
                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Address')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.correspondenceAddress || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Deliverability Indication')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.correspondenceDeliverabilityIndication ? (
                                                        <>
                                                            <RiCheckLine size="20" className="text-primary" />
                                                            {t('Yes')}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <RiCloseLine size="20" className="text-danger" />
                                                            {t('No')}
                                                        </>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>

                    {/* 3. Contact */}
                    <Col sm="12" md="12">
                        <Card className="h-100 h-100 shadow-sm">
                            <CardBody className="p-1">
                                <div className="d-flex align-items-center mb-2">
                                    <span className="me-2 text-primary">
                                        <RiContactsLine size="24" />
                                    </span>
                                    <div className="fw-bold font-size-16">
                                        {t('Contact Information')}
                                    </div>
                                </div>
                                
                                <Row>
                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Country Calling Code')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.countryCallingCode || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Phone Number')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.phoneNumber || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Fax Number')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.faxNumber || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>

                    {/* 3. Business Details */}
                    <Col sm="12" md="12">
                        <Card className="h-100 h-100 shadow-sm">
                            <CardBody className="p-1">
                                <div className="d-flex align-items-center mb-2">
                                    <span className="me-2 text-primary">
                                        <RiBriefcaseLine size="24" />
                                    </span>
                                    <div className="fw-bold font-size-16">
                                        {t('Business Details')}
                                    </div>
                                </div>
                                
                                <Row>
                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Line of Business')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.lineOfBusiness || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Legal Form')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.legalForm || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Location Status')}
                                                    <span
                                                        id="tooltip-locationStatus"
                                                        className="ms-1"
                                                        style={{ cursor: "pointer" }}>
                                                        <RiInformationLine />
                                                    </span>
                                                    <UncontrolledTooltip
                                                        target="tooltip-locationStatus"
                                                    >
                                                        {t('Organizational status of the establishment (e.g., SL = Single Location, HQ = Headquarter, BR = Branch)')}
                                                    </UncontrolledTooltip>
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.locationStatus || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Subsidiary Location')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.isSubsidiaryLocation ? (
                                                        <>
                                                            <RiCheckLine size="20" className="text-primary" />
                                                            {t('Yes')}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <RiCloseLine size="20" className="text-danger" />
                                                            {t('No')}
                                                        </>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Marketability Indication')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.marketabilityIndication || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Family Member Count')}

                                                    <span
                                                        id="tooltip-familyMemberCount"
                                                        className="ms-1"
                                                        style={{ cursor: "pointer" }}>
                                                        <RiInformationLine />
                                                    </span>
                                                    <UncontrolledTooltip
                                                        target="tooltip-familyMemberCount"
                                                    >
                                                        {t('The total number of family members within a family tree.  This count includes the global ultimate itself, all global ultimates branch locations, all subsidiaries, and all subsidiary branch locations.')}
                                                    </UncontrolledTooltip>
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.familyMemberCount || '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs='12' md="6" className="mb-2">
                                        <Row className="align-items-center py-1">
                                            <Col xs='12' md='4' className="d-flex align-items-center">
                                                <div className="fw-bold text-muted">
                                                    {t('Linkage Report Date')}
                                                </div>
                                            </Col>
                                            <Col xs='12' md='8' className="text-start">
                                                <div className="fw-bold">
                                                    {company.linkageReportDate ? (
                                                        dateUtils.convertDateToDate(
                                                            company.linkageReportDate, 
                                                            INTERNATIONAL_DATE_FORMAT
                                                        )
                                                    ) : '—'}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default withNamespaces()(
    GeneralInfo
)